import { render, staticRenderFns } from "./resource-metric.vue?vue&type=template&id=ae758356&"
import script from "./resource-metric.vue?vue&type=script&lang=js&"
export * from "./resource-metric.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports